<template>
  <div id="onboarding-content">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'Onboard'
}

</script>

<style lang="scss">
#app.onboard {
  @extend %background-main-dark;
}

#app.onboard.login,
#app.onboard.reset,
#app.onboard.recovery {
  background: $primary url('../assets/backgrounds/smoke-login.png') no-repeat left;
  background-size: contain;
}


#onboarding-content {
  background-color: $surface-alpha;
  width: 500px;
  height: auto;
  padding: 60px 40px;
  margin: 150px auto;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.1), 0 0 2px rgba(0, 0, 0, 0.1);

  h1 {
    @extend %type-alpha;
    color: $primary;
    font-weight: $regular;
    margin-top: 0;
  }

  .recovery {
    @extend %type-omega;
    float: right;
  }

  .help {
    @extend %type-legal;
    margin: -20px 0 20px;
  }
}
</style>
